import * as actionTypes from "../actions/actionType";
import _ from "lodash";
const initialState = {
  allSmsData: [],
  incomingSmsData: [],
  outgoingSmsData: [],
};
export const smsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_SMS_MESSAGES:
      return {
        ...state,
        allSmsData: action.payload,
      };

    case actionTypes.SEND_SMS_MESSAGE:
      return {
        ...state,
        outgoingSmsData: action.payload,
      };

    default:
      return state;
  }
};
